const getPublishedListingUrl = category =>
  category && category.publishedListingPage && category.publishedListingPage.url;

export default getPublishedListingUrl;
